/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const storeCandidateNoteDataSchema = z.object({
	content: z.string(),
})

export type StoreCandidateNoteDataSchema = z.infer<typeof storeCandidateNoteDataSchema>
